import { all, fork, takeEvery, call } from 'redux-saga/effects';
import { loadEntities, updateEntity, deleteEntity, fetchResource, showErrorMessage } from 'helpers/utilHelpers';
import {
  LOAD_EVENT,
  LOAD_EVENT_TYPES,
  LOAD_EVENTS,
  UPDATE_EVENT,
  UPDATE_EVENT_TYPE,
  DELETE_EVENT,
  DELETE_EVENT_TYPE,
  LOAD_LIST_EVENT,
  LOAD_EVENT_SCHEDULES,
  LOAD_EVENT_SCHEDULE,
  UPDATE_EVENT_SCHEDULE,
  DELETE_EVENT_SCHEDULE,
} from 'constants/ActionTypes';

function* deleteEvent() {
  yield takeEvery(DELETE_EVENT, deleteEntity);
}

function* deleteEventType() {
  yield takeEvery(DELETE_EVENT_TYPE, deleteEntity);
}

function* updateEvent() {
  yield takeEvery(UPDATE_EVENT, updateEntity);
}

function* updateEventType() {
  yield takeEvery(UPDATE_EVENT_TYPE, updateEntity);
}

function* loadEvents() {
  yield takeEvery(LOAD_EVENTS, loadEntities);
}

function* loadEventTypes() {
  yield takeEvery(LOAD_EVENT_TYPES, loadEntities);
}

function* loadEventSchedules() {
  yield takeEvery(LOAD_EVENT_SCHEDULES, loadEntities);
}

function* loadEventById() {
  yield takeEvery(LOAD_EVENT, loadEntities);
}

function* updateEventSchedule() {
  yield takeEvery(UPDATE_EVENT_SCHEDULE, updateEntity);
}

function* deleteEventSchedule() {
  yield takeEvery(DELETE_EVENT_SCHEDULE, deleteEntity);
}

function* loadEventSchedule() {
  yield takeEvery(LOAD_EVENT_SCHEDULE, loadEntities);
}

function* fetchListEvent(action) {
  const resource = 'events/list';
  const method = 'GET';
  const queryParams = {
    start: action.payload.params.startDate,
    end: action.payload.params.endDate,
  };

  try {
    const response = yield call(() => fetchResource(resource, method, null, null, queryParams));

    action.payload.onSuccess(response);
  } catch {
    if (action.payload.onErrorMessage) {
      yield showErrorMessage(action.payload.onErrorMessage);
    }
  }
}

function* loadListEvent() {
  yield takeEvery(LOAD_LIST_EVENT, fetchListEvent);
}

export default function* rootSaga() {
  yield all([
    fork(loadListEvent),
    fork(loadEventById),
    fork(deleteEvent),
    fork(deleteEventType),
    fork(updateEvent),
    fork(updateEventType),
    fork(loadEvents),
    fork(loadEventTypes),
    fork(updateEventSchedule),
    fork(deleteEventSchedule),
    fork(loadEventSchedule),
    fork(loadEventSchedules),
  ]);
}
